import ArrowSvgIcon from '@/public/images/icons/arrow_up.svg';
import NotificationsSvgIcon from '@/public/images/icons/notifications.svg';
import SyncSvgIcon from '@/public/images/icons/sync.svg';
import styled from 'styled-components';
import Typography from '../Typography';
import { AddEmailAccountButton } from './EmailAccounts/EmailAccount.styles';

export const AccountWrapper = styled.div(({ theme }) => ({
  padding: theme.spacing[20],
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  background: theme.colors.pageBackground,
  rowGap: theme.spacing[20],

  [`${theme.mediaBreakpointUp.lg}`]: {
    maxWidth: 800,
    paddingTop: theme.spacing[40],
    paddingBottom: theme.spacing[40],
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

export const AccountTitle = styled(Typography)(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
}));

export const AccountSectionWrapper = styled.div<{ isLoggedIn?: boolean; onClick?: () => void }>(
  ({ theme, isLoggedIn, onClick }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing[16],
    columnGap: theme.spacing[24],
    background: theme.colors.highEmphasisWhite,
    padding: theme.spacing[16],
    borderRadius: 4,
    boxShadow: '0px 0.5px 2px 0px #60617029, 0px 0px 1px 0px #28293D14',
    cursor: onClick ? 'pointer' : 'default',

    'div:first-child': {
      flex: 1,
    },

    [`${theme.mediaBreakpointUp.lg}`]: {
      padding: `${theme.spacing[24]} ${theme.spacing[20]}`,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: isLoggedIn ? 'flex-start' : 'center',
      rowGap: theme.spacing[32],

      [`${AddEmailAccountButton}`]: {
        justifyContent: 'flex-start',
      },
    },
  }),
);

export const AccountSectionTitle = styled(Typography)(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
}));

export const AccountSectionTitleWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing[8],
}));

export const AccountSectionSubText = styled(Typography)(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  marginTop: theme.spacing[4],

  [`${theme.mediaBreakpointUp.md}`]: {
    marginTop: theme.spacing[8],
  },
}));

export const AccountSectionArrow = styled(ArrowSvgIcon)(({ theme }) => ({
  color: theme.colors.mediumEmphasisBlack,
  transform: 'rotate(90deg)',
  marginLeft: 'auto',
}));

export const NotificationsIcon = styled(NotificationsSvgIcon)(({ theme }) => ({
  path: {
    fill: theme.colors.mediumEmphasisBlack,
  },
}));

export const SyncIcon = styled(SyncSvgIcon)(({ theme }) => ({
  path: {
    fill: theme.colors.mediumEmphasisBlack,
  },
}));

export const LoginBannerWrapper = styled.div<{ showOn: 'desktop' | 'mobile' }>(({ theme, showOn }) => ({
  display: showOn === 'desktop' ? 'none' : 'block',

  [`${theme.mediaBreakpointUp.lg}`]: {
    display: showOn === 'desktop' ? 'block' : 'none',
  },
}));
